import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Validacoes } from 'app/utils/validacoes';
import { Cadastro } from '../interfaces/cadastro';


@Injectable({
  providedIn: 'root'
})
export class CadastroUtilsService {
  
  buildForm(fb: FormBuilder, cad: Cadastro): FormGroup {
    return fb.group({
      // geral
      id: [cad?.id],
      codigo: [cad?.codigo],
      uuid: [cad?.uuid],
      desativado: [cad?.desativado],
      razaoSocial: [cad?.razaoSocial, [Validators.required]],
      nomeFantasia: [cad?.nomeFantasia, [Validators.required]],
      celular: [cad?.celular, [Validators.required]],
      telefone1: [cad?.telefone1],
      cep: [cad?.cep, [Validators.required]],
      cadMun: [cad?.cadMun, [Validators.required]],
      cadCadastroGrupo: [cad?.cadCadastroGrupo, [Validators.required]],
      endereco: [cad?.endereco, [Validators.required]],
      numero: [cad?.numero, [Validators.required]],
      complemento: cad?.complemento,
      bairro: [cad?.bairro, [Validators.required]],
      pessoa: [cad?.pessoa, [Validators.required]],
      contribuinteIcms: [cad?.contribuinteIcms, [Validators.required]],
      cpfCnpj: [cad?.pessoa === 'Fisica' ? cad?.cpf : cad?.inscricaoFederal, [Validators.required, Validacoes.validaCpfCnpj]],
      rgInscricao: [cad?.pessoa === 'Fisica' ? cad?.rg : cad?.inscricaoEstadual, [Validators.required]],
      cnh: [cad?.cnh],
      inscricaoFederal: [cad?.inscricaoFederal],
      uf: [cad?.cadMun?.uf],
      cpf: [cad?.cpf],
      rg: [cad?.rg],
      inscricaoEstadual: [cad?.inscricaoEstadual],
      inscricaoCadPro: [cad?.inscricaoCadPro],
      dataNasc: [cad?.dataNasc, [Validators.required]],
      email: [cad?.email],
      obs: [cad?.obs],
      cliente: [cad?.cliente || false],
      fornecedor: [cad?.fornecedor || false],
      vendedor: [cad?.vendedor || false],
      produtor: [cad?.produtor || false],
      funcionario: [cad?.funcionario || false],
      trabalhador: [cad?.trabalhador || false],
      transportador: [cad?.transportador || false],
      orgao: [cad?.orgao || false],
      motorista: [cad?.motorista || false],
      sindicato: [cad?.sindicato || false],
      lojaOnline: [cad?.lojaOnline || false],
      app: [cad?.app || false],
      empresaRemota: [cad?.empresaRemota || false],
      empresaAutomacao: [cad?.empresaAutomacao || false],
      empresaServicosMecanico: [cad?.empresaServicosMecanico || false],
      empresaTransporte: [cad?.empresaTransporte || false],
      empresaConsultoria: [cad?.empresaConsultoria || false],
      empresaMDFe: [cad?.empresaMDFe || false],
      urlApi: [cad?.urlApi],
      urlFotoLoja: [cad?.urlFotoLoja],
      urlLogo: [cad?.urlLogo],
      servidorLocal: [cad?.servidorLocal],
      filialApi: [cad?.filialApi],
      filialAccessApi: [cad?.filialAccessApi],
      socioAdm:[cad?.socioAdm],
      socioAdmEndereco: [cad?.socioAdmEndereco],
      searchCidade: '',
      searchSocio: '',
      searchEndereco: ''
    });
  }
  


}
